import thumbnailImg from 'Static/thumbnails/screenshot--homes.png';

export default {
  slug: 'homes',
  title: 'Homes',
  seriesNumber: '3',
  published: true,
  thumbnailImg,
  subject: 'Life Sciences',
  graphicFileName: 'Image_Homes.png',
  graphicAlt:
    'App screenshot of Homes depicting the inside of a kids’ room in a Western country',
  iconFileName: 'Icon_Homes.png',
  iconLargeFileName: 'Icon_Homes@2x.png',
  iconAlt: 'App icon for Homes depicting the outside of a home in the USA',
  description:
    'Topics covered include architecture, geography, culture, natural resources, utilities, and organization of space.',
  briefDescription: 'Learn about geography, architecture & more.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'cy',
    'da',
    'de',
    'el',
    'es',
    'et',
    'eu',
    'fa',
    'fi',
    'fl',
    'fr',
    'ga',
    'he',
    'hi',
    'hr',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'km',
    'ko',
    'lv',
    'ms',
    'nb',
    'nl',
    'pa',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sq',
    'sr',
    'sv',
    'sw',
    'ta',
    'te',
    'th',
    'tl',
    'tr',
    'ug',
    'uk',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'IntroScene',
    'MongolianGer_Exterior',
    'MongolianGer_Exterior_SliderOpen',
    'MongolianGer_Interior',
    'Guatemalan_Adobe_Exterior',
    'Guatemalan_Adobe_Exterior_CamTarget_Outhouse',
    'Guatemalan_Adobe_Exterior_CamTarget_Sink',
    'Guatemalan_Adobe_Exterior_CamTarget_Garden',
    'BrooklynBrownstoneExterior',
    'BrooklynBrownstone_Den',
    'BrooklynBrownstone_Kitchen_Main',
    'BrooklynBrownstone_Kidsroom_Main',
    'BrooklynBrownstone_Bathroom_Main',
    'YemeniTower_Exterior',
    'YemeniTower_FirstFloorRight',
    'YemeniTower_FirstFloorLeft',
    'YemeniTower_Bedroom_Camera_Target_Main',
    'YemeniTower_Mafraj_Main',
    'YemeniTower_RoofDeck',
    'Loupe_WashArea',
    'Loupe_Outhouse',
    'MongolianGer_Interior_Stove',
    'MongolianGer_Interior_TableLeft',
    'MongolianGer_Interior_Checkers',
    'MongolianGer_Interior_DrawersMidLeft',
    'MongolianGer_Interior_DrawersRight',
    'Guatemalan_Adobe_Exterior_SliderOpen',
    'Guatemalan_Adobe_Exterior_CamTarget_Paint_house',
    'GuatemalanAdobe_Interior',
    'GuatemalanAdobe_Interior_CameraTargetSewing',
    'GuatemalanAdobe_Interior_CameraTargetLoom',
    'Guatemalan_Adobe_Kitchen',
    'Guatemalan_Adobe_Kitchen_CameraTargetStove',
    'Guatemalan_Adobe_Kitchen_CameraTargetPropane',
    'Guatemalan_Adobe_Kitchen_CameraTargetTable',
    'BrooklynBrownstoneExterior_Rooms_SliderOpen',
    'BrooklynBrownstoneExterior_Utilities_SliderOpen',
    'BrooklynBrownstone_Den_CameraTargetCheckerboard',
    'BrooklynBrownstone_Den_CameraTargetPuzzle',
    'BrooklynBrownstone_Den_CameraTargetTrumpet',
    'BrooklynBrownstone_Laundryroom',
    'BrooklynBrownstone_Laundryroom_CameraTargetLaundry',
    'BrooklynBrownstone_Parlor',
    'BrooklynBrownstone_Parlor_CameraTargetCookBook',
    'BrooklynBrownstone_Parlor_CameraTargetRecordPlayer',
    'BrooklynBrownstone_Parlor_CameraTargetPhotos',
    'BrooklynBrownstone_Kitchen_Fridge',
    'BrooklynBrownstone_Kitchen_Stove',
    'BrooklynBrownstone_Kitchen_Dish_Washer',
    'BrooklynBrownstone_Kitchen_Counter_Right',
    'BrooklynBrownstone_Kitchen_Counter_Left',
    'BrooklynBrownstone_Kitchen_Table',
    'BrooklynBrownstone_Kidsroom_Music',
    'BrooklynBrownstone_Kidsroom_Books',
    'BrooklynBrownstone_Kidsroom_IPad',
    'BrooklynBrownstone_Kidsroom_Drawing0',
    'BrooklynBrownstone_Kidsroom_Drawing1',
    'BrooklynBrownstone_Kidsroom_Money',
    'BrooklynBrownstone_Kidsroom_Map',
    'BrooklynBrownstone_Bathroom_CameraTargetToilet',
    'BrooklynBrownstone_Bathroom_CameraTargetBathtub',
    'BrooklynBrownston_Masterbedroom',
    'BrooklynBrownstone_Office',
    'BrooklynBrownstone_Office_CameraTargetBulletinBoard',
    'BrooklynBrownstone_Office_CameraTargetDesk',
    'BrooklynBrownstone_Office_CameraTargetBookShelf',
    'YemeniTower_Exterior_SliderOpen',
    'YemeniTower_LivingRoom',
    'YemeniTower_LivingRoom_CameraTargetTable',
    'YemeniTower_LivingRoom_CameraTargetPictures',
    'YemeniTower_Pantry_Camera_Target_Main',
    'YemeniTower_Pantry_Baskets',
    'YemeniTower_Pantry_Pestle',
    'YemeniTower_Kitchen',
    'YemeniTower_Kitchen_Refrigerator',
    'YemeniTower_Kitchen_Sink',
    'YemeniTower_Kitchen_CookCurry',
    'YemeniTower_Kitchen_TandoriStove',
    'YemeniTower_Mafraj_orangeBook',
    'YemeniTower_Mafraj_TeaTable',
    'YemeniTower_Mafraj_oliveGreenBook',
    'YemeniTower_Mafraj_Ipad',
    'YemeniTower_Mafraj_lute',
    'YemeniTower_RoofDeck_Laundry',
    'YemeniTower_RoofDeck_Rugbeater',
  ],
  featuredPrintables: ['homes_day_life'],
  printables: [
    'homes_makes_house_home',
    'homes_comparing_homes',
    'concept_map',
    'generating_questions',
  ],
  topics: [
    'comparing_homes',
    'food_customs',
    'natural_resources',
    'daily_activities',
  ],
  appLinks: {
    appStoreLink: 'https://apps.apple.com/us/app/homes-by-tinybop/id922609543',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.Homes',
  },
};
